import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type LayoutMode = 'grid' | 'list' | 'masonry';

interface StoreUIState {
  layoutMode: LayoutMode;
  zoomLevel: number;
  setLayoutMode: (mode: LayoutMode) => void;
  setZoomLevel: (level: number) => void;
}

/**
 * Store UI Preference Persistence
 * Tracks user-specific layout choices (grid/list/masonry)
 */
export const useStoreUI = create<StoreUIState>()(
  persist(
    (set) => ({
      layoutMode: 'masonry',
      zoomLevel: 0,
      setLayoutMode: (mode: LayoutMode) => set({ layoutMode: mode }),
      setZoomLevel: (level: number) => set({ zoomLevel: level }),
    }),
    {
      name: 'akiles-store-layout',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
